import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ConfirmDelete = ({ onConfirm, title, testid, children }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button className="p-2 text-zinc-400 hover:text-rose-400" aria-label="Elimina" data-testid={testid}>{children}</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-[#0d0e12] border-white/10 text-white">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>Questa azione non può essere annullata.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="bg-transparent border-white/15" data-testid={`${testid}-cancel`}>Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-rose-600 hover:bg-rose-500" data-testid={`${testid}-confirm`}>Elimina</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
